import { Injectable } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';

import { Loggable } from 'app/utils/logging/loggable';

import {
  IncomingMessage,
  MessageType,
  NotificationMessage,
  PageLoadedNotification,
  ResponseMessage,
} from '../protocol';

@Injectable({
  providedIn: 'root',
})
export class MessagingService extends Loggable {
  public enableMessagingService = false;

  public messageRequest = new Subject<IncomingMessage>();
  public messageRequest$ = this.messageRequest.asObservable();

  private destroyed$ = new ReplaySubject<boolean>(1);

  public constructor() {
    super();
    this.setDisplayName('MessagingService');
    window.onmessage = this.handleMessage.bind(this);
  }

  public init(): void {
    this.destroyed$ = new ReplaySubject(1);
    this.enableMessagingService = true;

    const pageLoadedNotification: PageLoadedNotification = {
      type: MessageType.PAGE_LOADED_NOTIFICATION,
      context: 'preciate',
    };

    this.postNotification(pageLoadedNotification);
  }

  public handleMessage = (message: MessageEvent) => {
    const data = message.data;
    if (data.context !== 'preciate') {
      return;
    }

    this.info('Handle Message', data);

    this.messageRequest.next(data as IncomingMessage);
  };

  public postResponse(message: ResponseMessage): void {
    this.info('Post Response', message);
    window.top?.postMessage(message, '*');
  }

  public postNotification(notification: NotificationMessage): void {
    this.info('Post Notification', notification);
    window.top?.postMessage(notification, '*');
  }

  public postError(error: unknown): void {
    this.error('Post Error', error);
    window.top?.postMessage(error, '*');
  }

  public destroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
    window.onmessage = null;
  }
}
